"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/Phone` instead */
export const Phone = createSVGIcon(
  <path
    d="M9.035 21.712a5.58 5.58 0 0 1-3.51.793A5.5 5.5 0 0 1 2.28 21l-.76-.712a1.7 1.7 0 0 1-.52-1.22c0-.457.187-.895.52-1.222l3.225-3.056a1.85 1.85 0 0 1 1.267-.496c.474 0 .929.178 1.266.496.341.319.799.498 1.275.498.477 0 .935-.179 1.275-.498l5.067-4.852c.169-.16.303-.35.395-.559a1.65 1.65 0 0 0 0-1.324c-.092-.21-.226-.4-.395-.559a1.7 1.7 0 0 1-.518-1.213c0-.453.186-.889.518-1.213l3.209-3.072c.34-.32.798-.498 1.274-.498.477 0 .935.179 1.276.498l.743.727a5.08 5.08 0 0 1 1.57 3.109 5 5 0 0 1-.827 3.36c-3.496 4.934-7.944 9.183-13.105 12.518Z"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "Phone",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
